import React, { Component } from 'react';
import MyPATDialog from './MyPATDialog';
import { Button, Grid, Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setPopUpData } from './actions/focusedSectionAction';
import popUps from '../mylibrary/components/ContentCreate/wrapperComponent/popUps';

const styles = (theme: Theme) => createStyles({
    container: {
        display: 'flex',
        alignItems: 'center',
    },
    primaryBtn: {
        fontSize: '14px',
        fontWeight: 600,
        lineHeight: '19px',
        height: '44px',
        color: '#fff',
        backgroundColor: '#1D7DEA',
        padding: '8px 30px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#1D7DEA',
        }
    },
    heading: {
        flex: 1,
        color: '#333',
        textAlign: 'center',
        fontFamily: 'Nunito',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal'
    },
    headerContainer: {
        flex: 1
    },
    closeIcon: {
        fontSize: '32px',
        color: "#999999"
    },
    popUpContainer: {
        textAlign: 'center'
    },
    dialogContainer: {
        padding: 0,
        margin: 0
    }
})

interface Props extends WithStyles<typeof styles> {
    popUpData: any,
    setPopUpData: Function
}
interface States {
}

class PopUP extends Component<Props, States> {

    handleConfirmDeleteClose = () => {
        this.props.setPopUpData(null);
    }

    render() {
        const { popUpData, classes } = this.props;

        return popUpData && (
            <MyPATDialog
                dialogOpen
                otherDialogProps={{
                    fullWidth: true,
                    maxWidth: 'sm',
                }}
                customDialogActions={
                    <Button className={classes.primaryBtn} color="primary" onClick={this.handleConfirmDeleteClose}>Ok, Got it</Button>
                }
            >
                <Grid className={classes.popUpContainer}>
                    <div className={classes.container}>
                        <h1 className={classes.heading}>{popUpData.title}  </h1>
                        <span className={classes.closeIcon} onClick={this.handleConfirmDeleteClose}>&times;</span>
                    </div>
                    <img src={popUpData.imageUrl} alt="description" />
                    <p>{popUpData.description}</p>
                </Grid>
            </MyPATDialog>
        );
    }
}
const mapStateToProps = (state: any) => {
    return {
        popUpData: state.commonData.focusedSection.popUpData
    }
}


const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    setPopUpData
}, dispatch)

//@ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PopUP));